import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../component/Navbar";
import ProductHeader from "../../component/ProductHeader";
import Footer from "../../component/Footer";
import Images from "../../assets/Image";
import ContactUsFooter from "../../component/ContactUsFooter";
import MostlyViewed from "../../component/MostlyViewed";
import SpecificationViewed from "../../component/SepcificationViewed";
import FilePdf from "../../broucherPdf/filePdf";
import uspttoo3 from "../../assets/tto0305j.png";

export default function UspTto03s05s() {
  const [specificationVisible, setSpecificationVisible] = useState(false);
  const [youtubeVideoVisible, setYoutubeVideoVisible] = useState(false);
  const [printerDetailsVisible, setPrinterDetailsVisible] = useState(false);
  const containerRef = useRef(null);
  const youtubeContainerRef = useRef(null);
  const printerDetailsRef = useRef(null);

  const leftSidePrinterSpecification = [
    {
      title: "Print Head",
      data:
        "D03S: 32mm, 300 dpi (12 points/mm); D05S: 53mm, 300 dpi (12 points/mm)",
    },
    {
      title: "Print Area",
      data:
        "D03S: 32mm x 60mm (Intermittent), 32mm x 150mm (Continuous); D05S: 53mm x 70mm (Intermittent), 53mm x 150mm (Continuous)",
    },
    {
      title: "Ribbon Length",
      data: "D03S: 500m max; D05S: 600m max",
    },
    {
      title: "Ribbon Width",
      data: "D03S: 22mm - 33mm; D05S: 35mm - 55mm",
    },
    {
      title: "Interface",
      data: "USB, RS232, Network Interface",
    },
    {
      title: "Power Supply",
      data: "AC 100 - 240V, 50/60Hz, 200W",
    },
  ];

  const rightSidePrinterSpecification = [
    {
      title: "Operating Temperature",
      data: "0 - 40°C",
    },
    {
      title: "Relative Humidity",
      data: "10% - 95% (Non-Condensing)",
    },
    {
      title: "Air Supply",
      data: "6 bar / 90 PSI (max), dry, clean",
    },
    {
      title: "Weight",
      data:
        "D03S: Printer unit 8.5kg, Controller 2.0kg; D05S: Printer unit 9.5kg, Controller 2.0kg",
    },
    {
      title: "Printer Unit Dim. (L x W x H)",
      data: "D03S: 188mm x 190mm x 180mm; D05S: 210mm x 210mm x 180mm",
    },
    {
      title: "Controller Box Dim. (L x W x H)",
      data: "175mm x 235mm x 110mm",
    },
  ];

  const foodAndBeverage1 = [
    {
      productImg: Images?.industry5,
      label: "Food & Beverage",
      pageNavigate: "/byindustry/foodandbeverage",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSpecificationVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setYoutubeVideoVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (youtubeContainerRef.current) {
      observer.observe(youtubeContainerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setPrinterDetailsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (printerDetailsRef.current) {
      observer.observe(printerDetailsRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const downloadLinkRef = useRef(null);

  const handleDivClick = () => {
    if (downloadLinkRef.current) {
      downloadLinkRef.current.click();
    }
  };

  return (
    <div>
      <Navbar />
      <ProductHeader
        headerTxt="USP TTO 03S & 05S"
        printerImg={Images?.UspTto03jPrinter}
        pdfFile={FilePdf?.usp_TTO_D03S_D05S}
      />
      <div className="printerPageContainer">
        <div className="printerDetailsContainer">
          <header
            className={`printerDetailsHeader ${
              printerDetailsVisible ? "animated" : ""
            }`}
          >
            USP TTO 03S & 05S
          </header>
          <div
            ref={printerDetailsRef}
            className={`printerDetailsData ${
              printerDetailsVisible ? "animated" : ""
            }`}
          >
            The USP D-series Thermal Transfer Overprinters, among the
            world’s most cost-effective smart coding machines, provide excellent
            solutions to soft-packaging coding in a wide range of fields like
            food, pharmacy, daily-use chemicals and seeds. These models support
            both intermittent and continuous printing, and are built for
            reliable date, time and batch coding with user-friendly operation
            and long-life ribbon performance.
          </div>
          <div className="printerDetailsVideo" ref={youtubeContainerRef}>
            {/* <div className="printerYoutubeLink">
              <iframe
                className={`youtubeVideo ${
                  youtubeVideoVisible ? "animated" : ""
                }`}
                width="300"
                height="250"
                src="https://www.youtube.com/embed/jMFx1pUakkU?si=oDSbquQyGUGkTZEt"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                style={{ borderRadius: "6px" }}
              ></iframe>
            </div> */}
            <div>
              <div
                className={`printerBrochure ${
                  youtubeVideoVisible ? "animated" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={handleDivClick}
              >
                <div>
                  <div className="productImageContainer">
                    <img className="w-[100%]" src={uspttoo3} alt="" />
                  </div>
                  <div className="brochureImageButtons">
                    <button className="downloadBrochureBtn">
                      Download Brochure
                    </button>
                  </div>
                  <a
                    href={FilePdf?.usp_TTO_D03S_D05S}
                    download="USP TTO 03S & 05S"
                    ref={downloadLinkRef}
                    style={{ display: "none" }}
                  >
                    Download Brochure
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="printerSpecificationContainer">
          <header className="printerDetailsHeader">Specification</header>
          <div
            ref={containerRef}
            className="printerSpecificationDetailsContainer"
          >
            <div className="leftSideSpecificationContainer">
              {leftSidePrinterSpecification.map((item, index) => (
                <div
                  className={`specificationDetails ${
                    specificationVisible ? "animated" : ""
                  }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
            <div className="rightSideSpecificationContainer">
              {rightSidePrinterSpecification.map((item, index) => (
                <div
                  className={`rightSpecificationDetails ${
                    specificationVisible ? "animated" : ""
                  }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <SpecificationViewed foodAndBeverage1={foodAndBeverage1} />

        <MostlyViewed />
      </div>
      <ContactUsFooter />
      <Footer />
    </div>
  );
}
